import { Component, OnInit } from '@angular/core';
import { ShiftDataService } from '../shift-data.service';
import { MatDialogRef } from '@angular/material/dialog';
import { DashboardService } from 'app/services/dashboard.service';

@Component({
    selector: 'app-site-selection-dialog',
    templateUrl: './site-selection-dialog.component.html',
    styleUrls: ['./site-selection-dialog.component.scss'],
})
export class SiteSelectionDialogComponent implements OnInit {
    sites: any[] = [];
    sitesCopy: any[] = [];

    constructor(
        public shiftDataService: ShiftDataService,
        public dialogRef: MatDialogRef<SiteSelectionDialogComponent>,
        public dashboardService: DashboardService
    ) {}

    ngOnInit(): void {
        //sort assets/sitename (filter) in ascending order
        this.shiftDataService._masterSites.sort((a,b)=> a.site_name > b.site_name ? 1 : -1);
        this.sites = this.shiftDataService._masterSites;
        this.sitesCopy = this.shiftDataService._masterSites;
    }

    onSiteSelect(site: any) {
        this.shiftDataService.selectedMasterSite = site;
        localStorage.setItem('SelectedMasterSite', JSON.stringify(site));
        this.shiftDataService.onMasterSiteSelectionChange();
        this.dialogRef.close();
    }

    onSiteSearch(value: any) {
        if (value) {
            this.sites = [...this.sitesCopy].filter((site) =>
                String(site.site_name)
                    .toLowerCase()
                    .indexOf(value.toLowerCase()) >= 0
                    ? site
                    : null
            );
        } else {
            this.sites = [...this.sitesCopy];
        }
    }
}
